import { NgClass } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { MssFieldBaseFieldTypeComponent } from '@shared/components/formly/fields/mss-field-base.component';
import { MSS_FORMLY_IMPORTS } from '@shared/components/formly/formly-standalone-imports';
import { ModalService } from '@shared/services/modal.service';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

@Component({
  templateUrl: 'currency-multi-add.component.html',
  styleUrls: ['currency-multi-add.component.scss'],
  imports: [
    NgClass,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskDirective,
    ...MSS_FORMLY_IMPORTS,
  ],
  providers: [provideNgxMask({ thousandSeparator: ',' })],
})
export class CurrencyMultiAddFieldTypeComponent extends MssFieldBaseFieldTypeComponent {
  private readonly modalService = inject(ModalService);

  public static readonly defaultOptions: FormlyFieldConfig = {
    props: {
      addonStart: '£',
      min: 0,
      ...MssFieldBaseFieldTypeComponent.focusBlurZeroDefault,
    },
  };

  public get numColumns(): number {
    return this.props.numColumns ?? 3;
  }

  public openTooltip() {
    this.modalService
      .open({
        title: this.props.label,
        message: this.props.tooltip,
      })
      .then(
        () => null,
        () => null,
      );
  }
}
